/* tslint:disable */
/* eslint-disable */
/**
 * Price and Capacity Track & automatic reserve Service
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @enum {string}
 */

export const SeatTypes = {
    NUMBER_0: 0,
    NUMBER_1: 1
} as const;

export type SeatTypes = typeof SeatTypes[keyof typeof SeatTypes];



